import { FC, useContext, useEffect, useRef, useState } from "react";
import { Spinner } from "reactstrap";
import { useAuthContext } from "../Auth";
import { AppContext } from "../contexts/AppContextProvider";
import PageBodyAlt from "./layout/PageBodyAlt";
import { useUserEnvContext } from "../contexts/EnvContextProvider";

interface Props extends React.PropsWithChildren {
    children: JSX.Element
}
const SuperUserPageBase: FC<Props> = (props: Props) => {
    const { state } = useAuthContext()
    const appCtx = useContext(AppContext)
    const { isSuperUser } = useUserEnvContext()
    
    const [ctxLoaded, setCtxLoaded] = useState(false)
    const mounted = useRef(false)
    useEffect(() => {
        mounted.current = true
        return () => {
            mounted.current = false
        }
    }, [])
    useEffect(() => {
        // console.log(authCtx?.isLoading, appCtx?.appStoreLoaded, appCtx?.userCompanyLoaded)
        if (!state?.isLoading && appCtx?.appStoreLoaded) {
            const asAsync = async () => {
                // await sleep(500)
                if (mounted.current)
                    setCtxLoaded(true)
            }
            asAsync()
        }

    }, [state?.isLoading, appCtx?.appStoreLoaded])
    useEffect(() => {
        // console.log("Context loaded", ctxLoaded)
    }, [ctxLoaded])
    // return props.children

    if (ctxLoaded && !isSuperUser) {
        return <PageBodyAlt midScreen>Ingen tilgang</PageBodyAlt>
    }
    return ctxLoaded ? props.children : <PageBodyAlt midScreen><Spinner /></PageBodyAlt>
}

export default SuperUserPageBase